import { LocalDate } from "@js-joda/core";

export interface DateRange {
  dateFromInclusive: LocalDate;
  dateToInclusive: LocalDate;
}

export function isBeforeOrEqual(date1: LocalDate, date2: LocalDate): boolean {
  return date1.isBefore(date2) || date1.isEqual(date2);
}

export function isAfterOrEqual(date1: LocalDate, date2: LocalDate): boolean {
  return date1.isAfter(date2) || date1.isEqual(date2);
}

export function isBetweenInclusive(
  date: LocalDate,
  dateRange: DateRange
): boolean {
  return (
    isBeforeOrEqual(date, dateRange.dateToInclusive) &&
    isAfterOrEqual(date, dateRange.dateFromInclusive)
  );
}
